import {
  loadMyVerification,
  startIdentityVerification,
  uploadIdentityDocument,
} from 'api/services/verificationService'

import { SecurityVerificationFiles } from './verificationUtils'

export async function submitTenantVerificationDocuments(
  files: SecurityVerificationFiles
): Promise<void> {
  const verification = await loadMyVerification()
  if (verification.status === 'profile_incomplete') {
    await startIdentityVerification()
  }

  const uploads: Array<{ documentType: string; url: string }> = []
  const personalId = files.personalId?.[0]
  const proofOfIncome = files.proofOfIncome?.[0]
  const selfieWithId = files.selfieWithId?.[0]

  if (personalId) uploads.push({ documentType: 'government_id', url: personalId })
  if (proofOfIncome) uploads.push({ documentType: 'proof_of_income', url: proofOfIncome })
  if (selfieWithId) uploads.push({ documentType: 'selfie_with_id', url: selfieWithId })

  for (const upload of uploads) {
    await uploadIdentityDocument({
      documentType: upload.documentType,
      file: { url: upload.url },
    })
  }
}
